module.exports = __webpack_public_path__ + "static/media/Food04.efcc5fc0.jpg";